import {
  PLUGIN_TYPE_APPLICATION,
  PLUGIN_TYPE_MCP,
  PLUGIN_TYPE_MEMORY,
  PLUGIN_TYPE_INFINI_MEMORY,
  PLUGIN_TYPE_RAG,
  PLUGIN_TYPE_SANDBOX,
  PLUGIN_TYPE_SKILLGROUP,
  PLUGIN_TYPE_TOOLKIT,
  PLUGIN_TYPE_USER_TOOLKIT,
  PLUGIN_SUB_TYPE_APPLICATION,
  PLUGIN_SUB_TYPE_CLASS,
  PLUGIN_SUB_TYPE_INSTANCE,
  PLUGIN_SUB_TYPE_TOOLKIT,
  PLUGIN_SUB_TYPE_USER_TOOLKIT,
} from './plugin';

export const PLUGIN_TYPE_TO_NAV_KEY: Record<string, string> = {
  [PLUGIN_TYPE_SANDBOX]: 'sandboxes',
  [PLUGIN_TYPE_MCP]: 'mcps',
  [PLUGIN_TYPE_MEMORY]: 'memories',
  [PLUGIN_TYPE_INFINI_MEMORY]: 'memories',
  [PLUGIN_TYPE_RAG]: 'rags-build',
  [PLUGIN_TYPE_SKILLGROUP]: 'skillgroups',
};

export type PluginSubType =
  | typeof PLUGIN_SUB_TYPE_CLASS
  | typeof PLUGIN_SUB_TYPE_INSTANCE
  | typeof PLUGIN_SUB_TYPE_TOOLKIT
  | typeof PLUGIN_SUB_TYPE_USER_TOOLKIT
  | typeof PLUGIN_SUB_TYPE_APPLICATION;

export interface PluginTypeOption {
  value: string;
  label: string;
  pluginType: string;
  pluginSubType: PluginSubType;
  navKey?: string;
}

export const ALL_PLUGIN_OPTIONS: PluginTypeOption[] = [
  {
    value: `${PLUGIN_TYPE_SANDBOX}:${PLUGIN_SUB_TYPE_CLASS}`,
    label: '沙箱 - 模版',
    pluginType: PLUGIN_TYPE_SANDBOX,
    pluginSubType: PLUGIN_SUB_TYPE_CLASS,
    navKey: 'sandboxes',
  },
  {
    value: `${PLUGIN_TYPE_SANDBOX}:${PLUGIN_SUB_TYPE_INSTANCE}`,
    label: '沙箱 - 实例',
    pluginType: PLUGIN_TYPE_SANDBOX,
    pluginSubType: PLUGIN_SUB_TYPE_INSTANCE,
    navKey: 'sandboxes',
  },
  {
    value: `${PLUGIN_TYPE_SKILLGROUP}:${PLUGIN_SUB_TYPE_CLASS}`,
    label: '技能组 - 模版',
    pluginType: PLUGIN_TYPE_SKILLGROUP,
    pluginSubType: PLUGIN_SUB_TYPE_CLASS,
    navKey: 'skillgroups',
  },
  {
    value: `${PLUGIN_TYPE_SKILLGROUP}:${PLUGIN_SUB_TYPE_INSTANCE}`,
    label: '技能组 - 实例',
    pluginType: PLUGIN_TYPE_SKILLGROUP,
    pluginSubType: PLUGIN_SUB_TYPE_INSTANCE,
    navKey: 'skillgroups',
  },
  {
    value: `${PLUGIN_TYPE_RAG}:${PLUGIN_SUB_TYPE_CLASS}`,
    label: '知识库 RAG - 模版',
    pluginType: PLUGIN_TYPE_RAG,
    pluginSubType: PLUGIN_SUB_TYPE_CLASS,
    navKey: 'rags-build',
  },
  {
    value: `${PLUGIN_TYPE_RAG}:${PLUGIN_SUB_TYPE_INSTANCE}`,
    label: '知识库 RAG - 实例',
    pluginType: PLUGIN_TYPE_RAG,
    pluginSubType: PLUGIN_SUB_TYPE_INSTANCE,
    navKey: 'rags-build',
  },
  {
    value: `${PLUGIN_TYPE_MEMORY}:${PLUGIN_SUB_TYPE_CLASS}`,
    label: '记忆 - 模版',
    pluginType: PLUGIN_TYPE_MEMORY,
    pluginSubType: PLUGIN_SUB_TYPE_CLASS,
    navKey: 'memories',
  },
  {
    value: `${PLUGIN_TYPE_MEMORY}:${PLUGIN_SUB_TYPE_INSTANCE}`,
    label: '记忆 - 实例',
    pluginType: PLUGIN_TYPE_MEMORY,
    pluginSubType: PLUGIN_SUB_TYPE_INSTANCE,
    navKey: 'memories',
  },
  {
    value: `${PLUGIN_TYPE_MCP}:${PLUGIN_SUB_TYPE_CLASS}`,
    label: 'MCP - 模版',
    pluginType: PLUGIN_TYPE_MCP,
    pluginSubType: PLUGIN_SUB_TYPE_CLASS,
    navKey: 'mcps',
  },
  {
    value: `${PLUGIN_TYPE_MCP}:${PLUGIN_SUB_TYPE_INSTANCE}`,
    label: 'MCP - 实例',
    pluginType: PLUGIN_TYPE_MCP,
    pluginSubType: PLUGIN_SUB_TYPE_INSTANCE,
    navKey: 'mcps',
  },
  {
    value: `${PLUGIN_TYPE_TOOLKIT}:${PLUGIN_SUB_TYPE_TOOLKIT}`,
    label: '平台工具包',
    pluginType: PLUGIN_TYPE_TOOLKIT,
    pluginSubType: PLUGIN_SUB_TYPE_TOOLKIT,
  },
  {
    value: `${PLUGIN_TYPE_USER_TOOLKIT}:${PLUGIN_SUB_TYPE_USER_TOOLKIT}`,
    label: '用户工具包',
    pluginType: PLUGIN_TYPE_USER_TOOLKIT,
    pluginSubType: PLUGIN_SUB_TYPE_USER_TOOLKIT,
  },
  {
    value: `${PLUGIN_TYPE_APPLICATION}:${PLUGIN_SUB_TYPE_APPLICATION}`,
    label: '子代理',
    pluginType: PLUGIN_TYPE_APPLICATION,
    pluginSubType: PLUGIN_SUB_TYPE_APPLICATION,
  },
];
